// Keyboard shortcut help modal.
// Opens via help button, `?` (Shift+/), or Ctrl+/; closes via X, Esc, or backdrop.

import { isEditableElement } from '../shared/utils.ts';
import { hideModal, isOpenModal, showModal } from '../shared/modal.ts';

const OVERLAY_ID = 'shortcutHelpOverlay';
const BUTTON_ID = 'btnShortcutHelp';
const CLOSE_ID = 'shortcutHelpCloseBtn';

// showModal() moves focus onto the close button (the first control inside),
// keeps Tab in the dialog and hands focus back to the opener on close.
const openHelp = () => showModal(OVERLAY_ID);
const closeHelp = () => hideModal(OVERLAY_ID);
const isHelpOpen = () => isOpenModal(OVERLAY_ID);

export function initShortcutHelp(options: { signal?: AbortSignal } = {}) {
  const { signal } = options;

  const btn = document.getElementById(BUTTON_ID);
  if (btn) {
    btn.hidden = false;
    btn.removeAttribute('hidden');
    btn.addEventListener('click', openHelp, { signal });
  }

  document.getElementById(CLOSE_ID)?.addEventListener('click', closeHelp, { signal });

  const overlay = document.getElementById(OVERLAY_ID);
  overlay?.addEventListener('click', (e) => {
    if (e.target === overlay) closeHelp();
  }, { signal });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && isHelpOpen()) {
      e.preventDefault();
      closeHelp();
      return;
    }
    if (isEditableElement(e.target)) return;

    const isQuestion = e.key === '?' || (e.shiftKey && e.key === '/');
    const isCtrlSlash = (e.ctrlKey || e.metaKey) && e.key === '/';
    if (isQuestion || isCtrlSlash) {
      e.preventDefault();
      if (isHelpOpen()) closeHelp();
      else openHelp();
    }
  }, { signal });
}
